import React from "react";

export function Chips({ options, selected, onToggle }) {
  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {options.map((opt) => {
        const active = selected.includes(opt);
        return (
          <button
            key={opt}
            type="button"
            className={`chip ${active ? "active" : ""}`}
            onClick={() => onToggle(opt)}
            data-testid={`chip-${opt.replace(/\s+/g, "-").toLowerCase()}`}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}

export function FieldLabel({ children }) {
  return (
    <label className="block text-xs uppercase tracking-widest text-[#8B5E34] mb-2" style={{ fontFamily: "'Lora', Georgia, serif" }}>
      {children}
    </label>
  );
}

export function SectionLabel({ children }) {
  return <p className="section-label mt-5 mb-1">{children}</p>;
}

export function SelectField({ value, onChange, options, testid }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="input-field-box"
      style={{ fontFamily: "'Lora', Georgia, serif" }}
      data-testid={testid}
    >
      {options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
  );
}
